module.exports = __webpack_public_path__ + "img/car-mask-1.bda5dbbb.png";